module.exports = __webpack_public_path__ + "img/journey.74e84cf0.svg";